// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type ComponentType, type ReactNode } from 'react';
import { withTheme } from '../../../app/context/theme-context/index.tsx';
import type { ColumnId } from '../../../model/columns/index.tsx';
import type { CompiledTheme } from '../../../model/themes/index.tsx';
import { Wrapper, InnerWrapper, ShadowWrapper, HeaderShadow } from './styled.tsx';

type Props = {
	coreColumnIds: ColumnId[];
	additionalColumnIds: ColumnId[];
	isColumnConfigurationVisible: boolean;
	hasVerticallyScrolled: boolean;
	tableHasLeftShadow: boolean;
	tableHasRightShadow: boolean;
	bottomShadowWidth: number;
	isAutoRowHeight: boolean;
	theme: CompiledTheme;
	setHeaderHeight: (height: number) => void;
	AdditionalColumnsContainer: ComponentType<{
		children: ReactNode;
	}>;
	Column: ComponentType<{
		id: ColumnId;
	}>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ColumnConfiguration: ComponentType<Record<any, any>>;
};

// eslint-disable-next-line jira/react/no-class-components
class ColumnHeaders extends PureComponent<Props> {
	componentDidMount() {
		if (this.props.isAutoRowHeight && this.ref) {
			this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
		}
	}

	componentDidUpdate() {
		if (this.props.isAutoRowHeight && this.ref) {
			this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
		}
	}

	setRef = (el: HTMLElement | null) => {
		this.ref = el;
	};

	// @ts-expect-error - TS2564 - Property 'ref' has no initializer and is not definitely assigned in the constructor.
	ref: HTMLElement | null;

	renderCoreColumns() {
		const { coreColumnIds, Column } = this.props;
		return coreColumnIds.map((columnId) => <Column key={columnId} id={columnId} />);
	}

	renderAdditionalColumns() {
		const { additionalColumnIds, AdditionalColumnsContainer, Column } = this.props;

		return (
			<AdditionalColumnsContainer>
				{additionalColumnIds.map((columnId) => (
					<Column key={columnId} id={columnId} />
				))}
			</AdditionalColumnsContainer>
		);
	}

	render() {
		const {
			additionalColumnIds,
			bottomShadowWidth,
			isColumnConfigurationVisible,
			hasVerticallyScrolled,
			tableHasLeftShadow,
			tableHasRightShadow,
			ColumnConfiguration,
			theme,
		} = this.props;

		const styledCompProps = {
			hasScrolled: hasVerticallyScrolled,
			leftShadowVisible: tableHasLeftShadow,
			rightShadowVisible: tableHasRightShadow,
			width: bottomShadowWidth,
		};

		return (
			<Wrapper ref={this.setRef} {...styledCompProps} theme={theme}>
				<InnerWrapper {...styledCompProps} theme={theme}>
					{this.renderCoreColumns()}
					{additionalColumnIds.length > 0 && this.renderAdditionalColumns()}
					{isColumnConfigurationVisible && <ColumnConfiguration />}
					{theme.header.hasShadow && hasVerticallyScrolled && (
						<ShadowWrapper {...styledCompProps} theme={theme}>
							<HeaderShadow {...styledCompProps} theme={theme} />
						</ShadowWrapper>
					)}
				</InnerWrapper>
			</Wrapper>
		);
	}
}

export default withTheme(ColumnHeaders);
